import styled from '@emotion/styled';

export const ItemContainer = styled.div`
    margin-top: ${({ theme }) => theme.base.spacing[4]};
    padding-bottom: ${({ theme }) => theme.base.spacing[3]};
    border-bottom: 1px solid ${({ theme }) => theme.base.color.separator};
`;
